import React, { useEffect, useState } from 'react';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { FiDownload } from "react-icons/fi";
import { Base_Url, ratecsvuplode, fetchUser, ratecardList } from '../../../config/config'
import { toast } from 'react-toastify';
import { Upload, X, Eye } from 'lucide-react';
import { FileText, Sparkles, CheckCircle } from 'lucide-react';
import axios from 'axios';
import '../../../css/custom-scrollbar.css';
import Select from "react-dropdown-select";
import Papa from "papaparse";
import { useNavigate } from 'react-router-dom';

export default function SetRate() {
  
  const [file, setFile] = useState(null);
  const [Id, setId] = useState('')
  const [weight, setWeight] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [previewData, setPreviewData] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const navigate = useNavigate()

  const weightOptions = [
    { value: '200g', label: '200g' },
    { value: '500g', label: '500g' },
    { value: '1kg', label: '1kg' },
    { value: '5kg', label: '5kg' },
    { value: '10kg', label: '10kg' },
  ];

  useEffect(() => {
    fetchCustomers();
  }, [])

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
    setUploadSuccess(false);

    Papa.parse(uploadedFile, {
      complete: (results) => {
        setPreviewData(results.data);
      },
      header: true,
      skipEmptyLines: true,
    });
  };


  const handleUpload = async (event) => {
    event.preventDefault();
    if (!Id) {
      toast.error('Please select a seller first.');
      return;
    }
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    setIsUploading(true);
    if (file) {
      const formData = new FormData();
      formData.append('csv_file', file);
      formData.append('seller_id', Id)
      try {
        const response = await axios.post(Base_Url + "admin/" + ratecsvuplode, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': token,
            'cus_id': cus_id,
          },
        });
        setFile(null);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setIsUploading(false);
          setUploadSuccess(true);
          setTimeout(() => {
            navigate("/dasboard");
          }, 1000)
        }
        else if (response.data.status === "success") {
          toast.error(response.data.message + response.data.message);
        }
        else {
          toast.error(response.data.message + response.data.message);
          setIsUploading(false);
        }
      } catch (error) {
        setIsUploading(false);
      }
    }
  };

  const fetchRateCardList = async (selectedId) => {
    try {
      const url = Base_Url + ratecardList + "/" + selectedId;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token || '',
          cus_id: cus_id || '',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch data');
      }

      const result = await response.json();

      if (result && result.data) {
        return result.data;
      } else {
        console.error('Unexpected response structure:', result);
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('API error:', error.message);
      toast.error('Error fetching rate card data: ' + error.message);
      throw error;
    }
  };

  const handleDownloadRateCard = async () => {
    if (!Id) {
      toast.error('Please select an ID first.');
      return;
    }

    setIsDownloading(true);
    try {
      const rateCardData = await fetchRateCardList(Id);

      if (rateCardData && rateCardData.length > 0) {
        const csvContent = Papa.unparse(rateCardData, {
          header: true,
          columns: [
            'zone_name',
            'surface_price',
            'additional_surfaceprice_per500gm',
            'express_price',
            'additional_expressprice_per500gm',
            'partner',
            'min_cod_price',
            'cod_percentage'
          ]
        });

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `ratecard_${Id}_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success('Rate card downloaded successfully!');
      } else {
        toast.error('No rate card data found for this ID.');
      }
    } catch (error) {
      toast.error('Failed to download rate card: ' + error.message);
    } finally {
      setIsDownloading(false);
    }
  };

  const openPreviewModal = () => {
    setIsPreviewModalOpen(true);
  };
  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
  };

  const fetchCustomers = async () => {
    const url = Base_Url + fetchUser;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        const transformedData = data.data.map(user => {
          const capitalizedName = user.name.charAt(0).toUpperCase() + user.name.slice(1);
          return {
            value: user.id,
            label: `${capitalizedName} (${user.id})`,
          };
        });
        setCustomers(transformedData);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  }
  const handleSelectChange = (selected) => {
    if (selected.length > 0) {
      const selectedItem = selected[0];
      setId(selectedItem.value);
    }
  };

  const handleWeightChange = (selected) => {
    if (selected.length > 0) {
      const selectedItem = selected[0];
      setWeight(selectedItem.value);
    }
  };

  const selectControlStyles = (base) => ({
    ...base,
    padding: '2px',
    background: isDarkMode ? 'rgba(255,255,255,0.03)' : '#ffffff',
    border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid #d1d5db',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: '500',
    boxShadow: 'none',
    minHeight: '36px',
  });

  const selectOptionStyles = (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? isDarkMode ? 'rgba(99,102,241,0.2)' : '#000000'
      : state.isFocused
        ? isDarkMode ? 'rgba(99,102,241,0.1)' : '#f3f4f6'
        : 'transparent',
    color: state.isSelected
      ? isDarkMode ? '#a5b4fc' : '#ffffff'
      : isDarkMode ? '#E5E7EB' : '#1e293b'
  });

  const PreviewModal = () => {
    if (!previewData || previewData.length === 0) return null;

    const headers = Object.keys(previewData[0]);

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm overflow-y-auto p-4">
        <div className={`rounded-2xl shadow-2xl w-11/12 max-w-6xl max-h-[90vh] overflow-hidden border ${
          isDarkMode
            ? 'bg-gradient-to-br from-[#0B1120] to-[#111827] border-white/10 shadow-[0_0_60px_rgba(99,102,241,0.2)]'
            : 'bg-white border-black'
        }`}>

          {/* Header */}
          <div className={`flex justify-between items-center p-4 border-b ${
            isDarkMode
              ? 'bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600 border-white/10'
              : 'bg-black border-black'
          }`}>
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-white/15 backdrop-blur-sm rounded-lg ring-1 ring-white/20">
                <FileText className="w-5 h-5 text-white" />
              </div>
              <div>
                <h2 className="text-base font-bold text-white">
                  Data Preview
                </h2>
                <p className="text-gray-200 text-xs">Review your uploaded data</p>
              </div>
            </div>
            <button
              onClick={closePreviewModal}
              className="p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-white"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          {/* Content Area */}
          <div className="overflow-auto max-h-[70vh] p-4 custom-scrollbar">

            {/* Data Stats */}
            <div className={`mb-3 rounded-xl p-3 border ${
              isDarkMode
                ? 'bg-white/[0.03] border-white/10'
                : 'bg-gray-50 border-gray-300'
            }`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className={`p-2 rounded-lg ${
                    isDarkMode
                      ? 'bg-gradient-to-br from-indigo-500 to-purple-600 shadow-[0_0_15px_rgba(99,102,241,0.4)]'
                      : 'bg-black'
                  }`}>
                    <FileText className="w-3.5 h-3.5 text-white" />
                  </div>
                  <div>
                    <h3 className={`font-bold text-xs ${isDarkMode ? 'text-white' : 'text-black'}`}>Data Summary</h3>
                    <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                      Total Records: <span className={`font-bold ${isDarkMode ? 'text-indigo-300' : 'text-black'}`}>{previewData.length}</span> |
                      Columns: <span className={`font-bold ${isDarkMode ? 'text-indigo-300' : 'text-black'}`}>{headers.length}</span>
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>Showing first 50 rows</p>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className={`rounded-xl overflow-hidden border ${isDarkMode ? 'border-white/10' : 'border-gray-300'}`}>
              <div className="overflow-x-auto custom-scrollbar">
                <table className="w-full">
                  <thead className={`sticky top-0 ${
                    isDarkMode
                      ? 'bg-gradient-to-r from-[#1F2937] via-[#1a2332] to-[#1F2937]'
                      : 'bg-black'
                  }`}>
                    <tr>
                      {headers.map((header, index) => (
                        <th
                          key={index}
                          className="p-2.5 text-left font-semibold text-white text-[11px] uppercase tracking-wide border-r border-white/10 last:border-r-0"
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody className={`divide-y ${isDarkMode ? 'divide-white/5' : 'divide-gray-200'}`}>
                    {previewData.slice(0, 50).map((row, rowIndex) => (
                      <tr
                        key={rowIndex}
                        className={`transition-colors ${
                          isDarkMode
                            ? rowIndex % 2 === 0 ? 'bg-[#111827] hover:bg-[#1F2937]' : 'bg-[#0F172A] hover:bg-[#1F2937]'
                            : rowIndex % 2 === 0 ? 'bg-gray-50 hover:bg-gray-100' : 'bg-white hover:bg-gray-100'
                        }`}
                      >
                        {headers.map((header, colIndex) => (
                          <td
                            key={colIndex}
                            className={`p-2.5 text-xs border-r last:border-r-0 ${
                              isDarkMode
                                ? 'text-gray-300 border-white/5'
                                : 'text-black border-gray-200'
                            }`}
                          >
                            <div className="truncate max-w-xs" title={row[header]}>
                              {row[header]}
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
    
  return (
    <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${
      isDarkMode ? 'dark bg-[#0B1120]' : 'bg-white'
    }`}>
      {isPreviewModalOpen && <PreviewModal />}

      {/* Premium ambient glows */}
      {isDarkMode ? (
        <>
          <div className="pointer-events-none absolute -top-40 -left-32 h-[500px] w-[500px] rounded-full bg-indigo-600/15 blur-[120px]" />
          <div className="pointer-events-none absolute bottom-0 -right-32 h-[400px] w-[400px] rounded-full bg-purple-600/10 blur-[100px]" />
        </>
      ) : (
        <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 blur-3xl" />
      )}

      <NavBar />
      <div className="flex flex-1 overflow-hidden relative z-10">
                           <div
            className={`
              ${isToggleSidebar ? "w-64" : "w-[72px]"}
              m-3
              rounded-3xl
              ${glass}
              overflow-hidden
              transition-all
              duration-300
              ease-in-out
            `}
          >
            <Sidebar />
          </div>

        {/* Page body */}
        <div className={`flex flex-1 flex-col overflow-hidden w-full p-2 md:p-3 transition-colors duration-300 ${
          isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-200'
        }`}>
          <div className="w-full max-h-full">
            <div className={`border rounded-2xl overflow-hidden transition-all duration-300 ${
              isDarkMode
                ? 'bg-gradient-to-br from-[#111827] to-[#0F172A] border-gray-800 shadow-[0_0_40px_rgba(0,0,0,0.5)]'
                : 'bg-white border-gray-200'
            }`}>

              {/* Premium Header */}
              <div className={`px-4 py-3 ${
                isDarkMode
                  ? 'bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-600'
                  : 'bg-black'
              }`}>
                <div className="flex items-center space-x-2.5">
                  <div className="p-1.5 bg-white/15 backdrop-blur-sm rounded-lg ring-1 ring-white/20">
                    <Upload className="w-3.5 h-3.5 text-white" />
                  </div>
                  <h2 className="text-sm font-bold text-white">
                    Upload Rate Card
                  </h2>
                </div>
              </div>

              {/* Customer + Weight Selection side by side */}
              <div className='px-4 pt-4 grid grid-cols-2 gap-3'>
                <div>
                  <label htmlFor="Id" className={`block text-xs font-bold mb-2 flex items-center uppercase tracking-wider ${
                    isDarkMode ? 'text-gray-400' : 'text-gray-700'
                  }`}>
                    <span className={`w-1.5 h-1.5 rounded-full mr-2 shrink-0 ${
                      isDarkMode ? 'bg-indigo-400' : 'bg-black'
                    }`}></span>
                    <span className="truncate">Select Customer ID</span>
                  </label>
                  <Select
                    options={customers}
                    onChange={handleSelectChange}
                    className="w-full"
                    styles={{
                      control: selectControlStyles,
                      option: selectOptionStyles
                    }}
                  />
                </div>

                <div>
                  <label htmlFor="weight" className={`block text-xs font-bold mb-2 flex items-center uppercase tracking-wider ${
                    isDarkMode ? 'text-gray-400' : 'text-gray-700'
                  }`}>
                    <span className={`w-1.5 h-1.5 rounded-full mr-2 shrink-0 ${
                      isDarkMode ? 'bg-indigo-400' : 'bg-black'
                    }`}></span>
                    <span className="truncate">Select Weight</span>
                  </label>
                  <Select
                    options={weightOptions}
                    onChange={handleWeightChange}
                    className="w-full"
                    styles={{
                      control: selectControlStyles,
                      option: selectOptionStyles
                    }}
                  />
                </div>
              </div>

              {/* Download Button */}
              <div className="mt-3 px-4">
                <button
                  type="button"
                  onClick={handleDownloadRateCard}
                  disabled={!Id || isDownloading}
                  className={`w-full p-2.5 rounded-xl font-bold text-xs transition-all duration-300 border ${
                    !Id || isDownloading
                      ? isDarkMode 
                        ? 'bg-gray-800/40 cursor-not-allowed text-gray-500 border-gray-800' 
                        : 'bg-gray-100 cursor-not-allowed text-gray-400 border-gray-300'
                      : isDarkMode
                        ? 'bg-white/[0.03] hover:bg-white/[0.06] text-indigo-300 border-indigo-500/40 hover:border-indigo-500/60 hover:shadow-[0_0_20px_rgba(99,102,241,0.3)]'
                        : 'bg-white hover:bg-gray-100 text-black border-black'
                  }`}
                >
                  <div className="flex items-center justify-center space-x-2">
                    {isDownloading ? (
                      <div className={`w-3.5 h-3.5 border-2 rounded-full animate-spin ${
                        isDarkMode ? 'border-indigo-500/30 border-t-indigo-400' : 'border-gray-400 border-t-black'
                      }`}></div>
                    ) : (
                      <FiDownload className="w-3.5 h-3.5" />
                    )}
                    <span>{isDownloading ? 'Downloading...' : 'Download Current Rate Card'}</span>
                  </div>
                </button>
              </div>

              {/* File Upload Section */}
              <div className="p-4">
                <label className={`block text-xs font-bold mb-2 flex items-center uppercase tracking-wider ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-700'
                }`}>
                  <span className={`w-1.5 h-1.5 rounded-full mr-2 ${
                    isDarkMode ? 'bg-indigo-400' : 'bg-black'
                  }`}></span>
                  Upload Your CSV File
                </label>

                {/* Drag & Drop Zone */}
                <div className={`relative border-2 border-dashed rounded-2xl p-5 transition-all duration-300 cursor-pointer ${
                  isDarkMode
                    ? 'border-white/15 bg-white/[0.02] hover:bg-white/[0.04] hover:border-indigo-500/60 hover:shadow-[0_0_25px_rgba(99,102,241,0.15)]'
                    : 'border-gray-300 bg-gray-50 hover:border-black'
                }`}>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={handleFileChange}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  />

                  <div className="text-center">
                    <div className={`mx-auto w-10 h-10 rounded-full flex items-center justify-center mb-2.5 ${
                      isDarkMode
                        ? 'bg-gradient-to-br from-indigo-500 to-purple-600 shadow-[0_0_20px_rgba(99,102,241,0.4)]'
                        : 'bg-black'
                    }`}>
                      <Upload className="w-4 h-4 text-white" />
                    </div>
                    <p className={`text-xs font-bold mb-0.5 ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>
                      Drop your CSV file here or click to browse
                    </p>
                    <p className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>
                      Supports CSV files up to 10MB
                    </p>

                    {file && (
                      <div className={`mt-3 p-2 rounded-xl border inline-flex items-center gap-1.5 ${
                        isDarkMode
                          ? 'bg-emerald-500/10 border-emerald-500/40'
                          : 'bg-white border-black'
                      }`}>
                        <CheckCircle className={`w-3.5 h-3.5 ${isDarkMode ? 'text-emerald-400' : 'text-black'}`} />
                        <span className={`font-semibold text-xs ${isDarkMode ? 'text-emerald-300' : 'text-black'}`}>{file.name}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col md:flex-row gap-2 mt-3">
                  <button
                    type="button"
                    onClick={handleUpload}
                    disabled={!file || isUploading}
                    className={`flex-1 p-2.5 rounded-xl font-bold text-xs transition-all duration-300 ${
                      !file || isUploading
                        ? isDarkMode
                          ? 'bg-gray-800/40 cursor-not-allowed text-gray-500'
                          : 'bg-gray-100 cursor-not-allowed text-gray-400'
                        : isDarkMode
                          ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:shadow-[0_0_25px_rgba(99,102,241,0.5)] hover:scale-[1.02]'
                          : 'bg-black hover:bg-gray-800 text-white'
                    }`}
                  >
                    <div className="flex items-center justify-center space-x-2">
                      {isUploading ? (
                        <div className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                      ) : (
                        <Upload className="w-3.5 h-3.5" />
                      )}
                      <span>{isUploading ? 'Processing...' : 'Upload & Process'}</span>
                    </div>
                  </button>

                  {file && previewData && (
                    <button
                      type="button"
                      onClick={openPreviewModal}
                      className={`flex-1 md:flex-none md:px-4 p-2.5 rounded-xl font-bold text-xs border transition-all duration-300 ${
                        isDarkMode
                          ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 hover:shadow-[0_0_15px_rgba(99,102,241,0.4)]'
                          : 'bg-white hover:bg-gray-100 text-black border-black'
                      }`}
                    >
                      <div className="flex items-center justify-center space-x-2">
                        <Eye className="w-3.5 h-3.5" />
                        <span>Preview Data</span>
                      </div>
                    </button>
                  )}
                </div>
              </div>

              {/* Template Download */}
              <div className="mx-4 mb-4">
                <div className={`rounded-2xl p-3.5 border transition-all duration-300 ${
                  isDarkMode
                    ? 'bg-white/[0.02] border-white/10'
                    : 'bg-gray-50 border-gray-200'
                }`}>
                  <div className="flex items-center justify-between gap-2 flex-wrap">
                    <div className="flex items-center space-x-2.5">
                      <div className={`p-2 rounded-lg shrink-0 ${
                        isDarkMode
                          ? 'bg-sky-500/10 border border-sky-500/30'
                          : 'bg-black'
                      }`}>
                        <FileText className={`w-3.5 h-3.5 ${isDarkMode ? 'text-sky-400' : 'text-white'}`} />
                      </div>
                      <div>
                        <h3 className={`font-bold text-xs ${isDarkMode ? 'text-white' : 'text-black'}`}>Need a template?</h3>
                        <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Download our pre-formatted CSV template</p>
                      </div>
                    </div>
                    <a
                      href="/sampleFile/ratecard 5.csv"
                      download="ratecard.csv"
                      className={`px-3.5 py-2 rounded-xl font-bold text-xs transition-all duration-300 flex items-center space-x-1.5 ${
                        isDarkMode
                          ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white hover:shadow-[0_0_20px_rgba(16,185,129,0.5)]'
                          : 'bg-black hover:bg-gray-800 text-white'
                      }`}
                    >
                      <FiDownload className="w-3.5 h-3.5" />
                      <span>Download Template</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}